import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../Login/LoginPage.css";
import { Button, Card } from "react-bootstrap";
import { BsCheckCircle, BsEmojiFrown, BsInfoCircle } from "react-icons/bs";

interface VerificationResponse {
  message: string;
  user: string;
  email: string;
  alreadyVerified?: boolean;
}

const EmailVerificationPage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const email = params.get("email");
  const navigate = useNavigate();
  const [verificationResponse, setVerificationResponse] =
    useState<VerificationResponse | null>(null);

  useEffect(() => {
    let response: any;
    if (token) {
      const verifyUrl = email
        ? `${process.env.REACT_APP_BACKEND_URL}/api/verifyemail?token=${token}&email=${email}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/verifyemail?token=${token}`;

      fetch(verifyUrl)
        .then(response => response.json())
        .then(data => {
          response = data;
          setVerificationResponse(response);
        })
        .catch(error => {
          console.error("Error verifying email:", error);
          setVerificationResponse({
            message: "Error verifying email",
            user: "n/a",
            email: "n/a",
          });
        });
    }
  }, [token, email]);

  return (
    <div className="parent-div">
      {!verificationResponse && (
        <div className="alert alert-info">Verifying...</div>
      )}

      {verificationResponse &&
        verificationResponse.message === "Email verified successfully" && (
          <Card
            style={{
              width: "18rem",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <Card.Header
              style={{
                backgroundColor: "#02b875",
                color: "white",
                textAlign: "center",
                padding: "2rem",
              }}
            >
              <BsCheckCircle size={"100px"} />
              <br />
              <br />
              <div>SUCCESS</div>
            </Card.Header>
            <Card.Body
              style={{ textAlign: "center", backgroundColor: "white" }}
            >
              <br />
              <Card.Text>
                Your email is verified. Sign in to continue to Reviewed.
              </Card.Text>
              <br />
              <Button variant="success" onClick={() => navigate("/login")}>
                Continue
              </Button>
            </Card.Body>
          </Card>
        )}

      {verificationResponse &&
        verificationResponse.message === "Email already verified" && (
          <Card
            style={{
              width: "18rem",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <Card.Header
              style={{
                backgroundColor: "#007bff",
                color: "white",
                textAlign: "center",
                padding: "2rem",
              }}
            >
              <BsInfoCircle size={"100px"} />
              <br />
              <br />
              <div>ALREADY VERIFIED</div>
            </Card.Header>
            <Card.Body
              style={{ textAlign: "center", backgroundColor: "white" }}
            >
              <br />
              <Card.Text>
                Your email is already verified. Sign in to continue to Reviewed.
              </Card.Text>
              <br />
              <Button variant="primary" onClick={() => navigate("/login")}>
                Sign in to Reviewed
              </Button>
            </Card.Body>
          </Card>
        )}

      {verificationResponse &&
        verificationResponse.message !== "Email verified successfully" &&
        verificationResponse.message !== "Email already verified" && (
          <Card
            style={{
              width: "18rem",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <Card.Header
              style={{
                backgroundColor: "#d9534f",
                color: "white",
                textAlign: "center",
                padding: "2rem",
              }}
            >
              <BsEmojiFrown size={"100px"} />
              <br />
              <br />
              <div>SOMETHING WENT WRONG</div>
            </Card.Header>
            <Card.Body
              style={{ textAlign: "center", backgroundColor: "white" }}
            >
              <br />
              <Card.Text>
                We couldn’t verify your email. Reopen the link in your latest
                verification email and try again.
              </Card.Text>
              <br />
              <Button variant="danger" onClick={() => navigate("/login")}>
                Continue
              </Button>
            </Card.Body>
          </Card>
        )}
    </div>
  );
};
export default EmailVerificationPage;
